import { Injectable, Injector, inject } from '@angular/core';
import { AppError } from '@api/errors/models/app-error.types';
import { AuthService } from '@authentication/services/auth.service';

const AUTHENTICATION_ENDPOINTS = ['/auth/refresh', '/auth/logout'];

@Injectable({ providedIn: 'root' })
export class AuthenticationErrorHandler {
  private readonly _injector = inject(Injector);

  async handle(error: AppError): Promise<void> {
    if (AUTHENTICATION_ENDPOINTS.some((endpoint) => error.httpError.url?.includes(endpoint))) {
      return;
    }

    // TODO LV2-495: service need to be injected here to avoid circular dependency issue with AuthService
    await this._injector.get(AuthService).logout();
  }
}
